import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import Title from "../../components/titles/Title";

const EcoBeeSubsection = ({
  image,
  description,
  alt,
  features,
  featureTitle,
}) => {
  return (
    <Container className="section-container">
      <Title heading={featureTitle} classname="mb-3 text-center" />

      <Row className="justify-content-between align-items-center">
        <Col md={3}>
          <img src={image} alt={alt} width="100%" />
        </Col>
        <Col md={9}>
          <p>{description}</p>
          {features &&
            features.map((item,index) => {
              return (
                <p key={index}>
                  <b>{item.title}</b>: {item.content}
                </p>
              );
            })}
        </Col>
      </Row>
    </Container>
  );
};

export default EcoBeeSubsection;
